module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/Playade-Gros-53c0efc9ab2b6404a4a66b2de70c331a.jpg";